var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-grid',_vm._b({attrs:{"border":"","resizable":"","columns":_vm.columns,"data":_vm.realTableData}},'vxe-grid',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }